<template>
  <el-drawer
    :title="data.name"
    :visible.sync="drawer"
    size="70%"
    v-bind="$attrs"
  >
    <el-row class="filaPrinc">
      <el-col>
        <el-row :gutter="10" class="filaPrinc">
          <el-col :span="12">
            <el-row :gutter="5">
              <el-col :span="6">
                <span>Codigo del Cliente: </span>
              </el-col>
              <el-col :span="12">
                <span class="black-text font-weight-800">{{
                  data.original.post_region
                }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="5">
                <span> Telefono: </span>
              </el-col>
              <el-col :span="12">
                <span class="black-text font-weight-800">{{
                  data.original.phone
                }}</span>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-col :span="4">
                <span>Direccion: </span>
              </el-col>
              <el-col :span="15">
                <span class="black-text font-weight-800">{{
                  data.original.post_street_address +
                  ", " +
                  data.original.post_city
                }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="7">
                <span>Coreo electronico:</span>
              </el-col>
              <el-col :span="12">
                <span class="black-text font-weight-800">{{
                  data.original.login
                }}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <div class="card-base card-shadow--medium">
              <el-table :data="items" :max-height="700" v-loading="loading">
                <el-table-column :width="80" align="center" fixed>
                  <template slot="header" slot-scope="scope">
                    <i class="el-icon-setting" :key="scope.$index"></i>
                  </template>

                  <template slot-scope="scope">
                    <el-tooltip content="Ver historial del GPS">
                      <el-button
                        type="info"
                        icon="mdi mdi-history"
                        :key="scope.$index"
                        size="mini"
                        @click="openHistoryDetail(scope.row)"
                      ></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="id"
                  label="ID #"
                  :width="90"
                ></el-table-column>
                <el-table-column
                  prop="label"
                  label="Titulo"
                  :min-width="140"
                ></el-table-column>
                <el-table-column
                  prop="source.phone"
                  label="Telefono"
                  :min-width="130"
                ></el-table-column>
                <el-table-column
                  prop="model_name"
                  label="Modelo"
                  :min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="source.connection_status"
                  label="Estado"
                  align="center"
                  :width="120"
                  :filters="[
                    { text: 'Activo', value: 'active' },
                    { text: 'Estacionado', value: 'idle' },
                    { text: 'Offline', value: 'offline' },
                    { text: 'Señal perdida', value: 'signal_lost' },
                    { text: 'Recién registrado', value: 'just_registered' }
                  ]"
                  :filter-method="filterConectionStatus"
                >
                  <el-tag
                    slot-scope="{ row }"
                    :type="getTagType(row.source.connection_status)"
                    >{{ row.source.connection_status }}</el-tag
                  >
                </el-table-column>
                <el-table-column
                  prop="clone"
                  label="Es clon?"
                  :width="90"
                  :filters="[
                    { text: 'Clonado', value: true },
                    { text: 'No clonado', value: false }
                  ]"
                  :filter-method="filterClone"
                >
                  <template slot-scope="{ row }">
                    <i v-if="row.clone" class="el-icon-check"></i>
                    <i v-else class="el-icon-close"></i>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="creation_date"
                  label="Activacion"
                  :width="110"
                ></el-table-column>
                <el-table-column
                  prop="last_connection"
                  label="Ultima conexión"
                  :width="165"
                ></el-table-column>
                <el-table-column
                  prop="DiasTrans"
                  label="Dias sin conexion"
                  align="center"
                  :width="160"
                ></el-table-column>
              </el-table>
              <div style="margin: 10px">
                <el-pagination
                  style="margin-top: 20px"
                  layout="total, sizes, prev, pager, next, jumper"
                  :current-page="pagination.currentPage"
                  :page-size="pagination.pageSize"
                  :total="pagination.total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                ></el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <report-gps-detail-history ref="history_detail" />
  </el-drawer>
</template>

<script>
import { mapMutations } from "vuex";

import ReportGpsDetailHistory from "@/components/reports/ReportsGpsDetailHistory.vue";
import { getPaginatedItems } from "@/utils";

export default {
  name: "ReportGpsDetail",
  components: {
    ReportGpsDetailHistory
  },
  data() {
    return {
      loading: false,
      drawer: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },

      // tableData:[{
      //   fechaActual: "",
      // }],
      data: {},
      activeType: "",
      originalItems: [],
      items: [],
      actions: [
        {
          command: "history_detail",
          icon: "mdi mdi-history",
          label: "Ver historial"
        }
      ],
      columns: [
        {
          prop: "id",
          label: "#",
          width: 80
        },
        {
          prop: "label",
          label: "Titulo",
          "min-width": 140
        },
        {
          prop: "model_name",
          label: "Modelo",
          "min-width": 100
        },
        {
          prop: "source.connetion_status",
          label: "Estado",
          formatter: (row) => row.source.connection_status,
          width: 120
        },
        {
          prop: "source.phone",
          label: "Teléfono",
          formatter: (row) => row.source.phone
        },
        {
          prop: "clone",
          label: "Es clon ?",
          width: 90
        },
        {
          prop: "creation_date",
          label: "Activacion"
        },
        {
          prop: "last_connection",
          label: "Ultima conexión"
        }
      ]
    };
  },
  // created(){
  //   this.DaysWithoutConnections()
  // },
  methods: {
    ...mapMutations("navixy", ["current_user"]),
    getPaginatedItems,
    show(data, type) {
      // Setear el usuario de navixy actual

      this.current_user(data.original);

      this.activeType = type;

      this.data = data;

      if (data.original.post_region === undefined) {
        data.original.post_region = " ";
      }

      if (data.original_trackers !== undefined) {
        data.original_trackers = data.original_trackers.map((trackers) => {
          trackers.label = trackers.label.toUpperCase();
          return trackers;
        });
      }

      if (type !== "total_gps") {
        this.data.trackers = data.trackers.filter(
          (tracker) => tracker.source.connection_status === type
        );
      } else {
        this.data.trackers = data.original_trackers;
      }
      this.pagination.total = this.data.trackers.length;

      this.drawer = true;
      this.handleCurrentChange(1);
      this.DaysWithoutConnections();
    },
    handleSizeChange(val) {
      this.loading = true;
      this.pagination.pageSize = val;
      const { data } = this.getPaginatedItems(
        this.data.trackers,
        this.pagination.currentPage,
        this.pagination.pageSize
      );
      this.loading = false;
      this.items = data;
    },
    handleCurrentChange(val) {
      this.loading = true;
      this.pagination.currentPage = val;
      const { data } = this.getPaginatedItems(
        this.data.trackers,
        this.pagination.currentPage,
        this.pagination.pageSize
      );
      this.loading = false;
      this.items = data;
    },
    openHistoryDetail(row) {
      this.$refs.history_detail.show(row, this.activeType);
    },
    getTagType(connection_status) {
      if (connection_status === "active") {
        return "success";
      } else if (connection_status === "idle") {
        return "primary";
      } else if (connection_status === "signal_lost") {
        return "warning";
      } else if (connection_status === "offline") {
        return "danger";
      }
      return "";
    },
    filterConectionStatus(value, row) {
      const { connection_status } = row.source;
      return connection_status === value;
    },
    filterClone(value, { clone }) {
      return value === clone;
    },
    DaysWithoutConnections() {
      let diaEnMils = 1000 * 60 * 60 * 24;
      let date = new Date();
      /*
       const count = this.items[0].push({fechaActual: date});
       */
      let desde;
      //let hasta = new Date(date.substr(0, 10))
      let DiasTranscurridos = [];
      let dif;
      let dias;
      // let meses;
      // let años
      for (let i in this.items) {
        if (this.items[i].last_connection != undefined) {
          desde = new Date(this.items[i].last_connection.substr(0, 10));
        }
        dif = Math.floor(date.getTime() - desde.getTime());

        dias = Math.floor(dif / diaEnMils);
        DiasTranscurridos.push(dias);
      }

      var index = 0;
      let elItems = [];
      this.items.forEach((item) => {
        elItems.push({
          DiasTrans: DiasTranscurridos[index],
          ...item
        });
        index++;
      });
      this.items = elItems;

      // let dif = date.getTime() - desde.getTime() + diaEnMils;

      // DiasTranscurridos = dif/diaEnMils;

      //const count = this.items.push({DiasTrans: DiasTranscurridos});

      // this.tableData.fechaActual= date;
    }
  }
};
</script>

<style scoped>
.filaPrinc {
  margin-top: 15px;
  margin-left: 15px;
  padding-left: 30px;
  padding: true;
}
</style>
